import React, { useEffect, useRef, useState } from "react";

/**
 * @param ratio 宽高比, 例如正方形为1, 手机屏幕就是 2.16 等
 * @param style
 * @param children
 * @param rest
 * @returns {Element}
 * @constructor
 */
export const RatioDiv = ({ ratio = 0.65, style = {}, children, ...rest }) => {
  const [height, setHeight] = useState("100%");
  const ref = useRef();
  useEffect(() => {
    if (ref.current) {
      setHeight(ref.current.clientWidth * ratio);
    }
  }, [ref.current]);
  return (
    <div
      ref={ref}
      {...rest}
      style={{
        height,
        ...style,
      }}
    >
      {/*当高度为100%时，不显示children,原因是children会撑开高度*/}
      {height === "100%" ? null : children}
    </div>
  );
};

export const RatioImage = ({ src,style={}, ...rest }) => {
  return (
    <RatioDiv
      {...rest}
      style={{
        background: `url(${src}) no-repeat center center / contain`,
        backgroundColor: "#f5f5f5",
        ...style,
      }}

    />
  );
};


export const RatioImageCover = ({ src,style={}, ...rest }) => {
  return (
    <RatioDiv
      {...rest}
      style={{
        background: `url(${src}) no-repeat center center / cover`,
        ...style,
      }}
    />
  );
}



// WEBPACK FOOTER //
// ./src/containers/Video/widgets/ratio-image.js